import React from "react";
import './BannerProtect.css';
import ChangeLink from "../../../Elements/ChangeLink/ChangeLink";

function BannerProtect(props) {
    function TextSource(info) {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*' + info.children}</>} catch (err) {return <>*{info.children}</>}}
    return (
            <div className="BannerProtect">
            <div className="BannerProtectRight">
                <div className="BannerProtectTitle">
                    <TextSource ArrIndex= 'index0200'>Protecting Your Funds</TextSource>,
                    <br/>
                    <TextSource ArrIndex= 'index0205'>Ensuring Fair Execution</TextSource>
                </div>
                <div className="BannerProtectText">
                    <ul>
                        <li><TextSource ArrIndex= 'index0210'>SEGREGATED CLIENT</TextSource> </li>
                        <li><TextSource ArrIndex= 'index0215'>REGULATED LIQUIDITY PROVIDERS</TextSource> </li>
                        <li><TextSource ArrIndex= 'index0220'>STP TECHNOLOGY</TextSource> </li>
                    </ul>
                    <div className="BannerProtectButton ButtonOut">
                        <ChangeLink to={'/providers'} lang={props.lang} style={{textDecoration: 'none'}}>
                            <div className='ButtonYellow'>
                                <TextSource ArrIndex= 'index0225'>FIND OUT MORE</TextSource>
                            </div>
                        </ChangeLink>
                    </div>
                </div>

            </div>
            </div>
    )}

export default BannerProtect





